import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Coins } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

export default function CreditBalancePill() {
  const { t } = useTranslation();
  const { credits, user, isAdmin } = useAuth();
  if (!user) return null;
  if (isAdmin) {
    return (
      <Link
        to="/billing"
        className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs bg-violet-100 text-violet-700 font-medium"
        title="Admin · unlimited"
      >
        <Coins className="w-3.5 h-3.5" />
        Admin
      </Link>
    );
  }
  const balance = credits?.balance ?? user.credit_balance ?? 0;
  const low = balance < 10;
  return (
    <Link
      to="/billing"
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${
        low ? 'bg-amber-100 text-amber-800' : 'bg-emerald-100 text-emerald-800'
      }`}
      title={t('credits.balance')}
    >
      <Coins className="w-3.5 h-3.5" />
      {Math.round(balance)} {t('credits.balanceShort', { count: Math.round(balance) }).split(' ')[1]}
    </Link>
  );
}
